import { Platform } from 'react-native';
import { useIsMobileLayout } from './useIsMobileLayout';

export const useIsWebDesktop = () => {
    return !useIsMobileLayout() && Platform.OS === 'web';
};
